import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useRef } from "react";
import classnames from "classnames";
import ArrowDown from "static/svg/arrow-down.svg";
import { withGenericConfig } from "contexts/generic-config-context";
import BadgeComponent from "components/core/badge/badge-component";
import { generateOnKeyDownHandler, preventFocusOnMouseDown } from "client/services/accessibility/accessibility-service";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { StyledLinkWithSectionsMenuComponent } from "./link-with-menu-component.scss";
import PictureComponent from "/components/core/picture/picture-component";
const LinkWithSectionsMenuComponent = (props)=>{
    const menuEl = useRef(null);
    const { isOpen, title, translate, id, openLinksMenu, links, TitleIcon, headerCatalogLinks } = props;
    const openMenu = ()=>{
        const menuId = isOpen ? null : id;
        openLinksMenu(menuId);
    };
    const getStyle = ()=>{
        var _menuEl_current;
        // Don't break if menuEl is not yet set or clientHeight is not available for some reason
        // in such case, set height to auto (will disable animation tho)
        const collapseHeight = (menuEl === null || menuEl === void 0 ? void 0 : (_menuEl_current = menuEl.current) === null || _menuEl_current === void 0 ? void 0 : _menuEl_current.clientHeight) || "auto";
        return isOpen ? {
            height: collapseHeight
        } : {
            overflow: "hidden",
            height: 0
        };
    };
    const renderSection = ({ section, sectionIndex })=>{
        const { mobileTitle, title, menuSectionItems, hideOnMobile } = section;
        const onLinkClick = (e, link)=>{
            preventFocusOnMouseDown(e);
            fireGtmEvent(DataLayerEventTypes.CLICK_MAIN_NAV, {
                click_text: translate(link === null || link === void 0 ? void 0 : link.title),
                parent_category: link === null || link === void 0 ? void 0 : link.itemType
            });
        };
        return !hideOnMobile && /*#__PURE__*/ _jsxs("div", {
            className: "section-wrapper",
            children: [
                (mobileTitle || title) && /*#__PURE__*/ _jsx("div", {
                    className: "section-link",
                    children: translate(mobileTitle || title)
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: menuSectionItems.map((link, linkIndex)=>{
                        const { title: linkTitle, url, isPopular, badgeText, badgeColorName, badgeTextColorName, badgeStrokeColorName, openInNewTab, mobileIcon: MobileIcon } = link;
                        var _headerCatalogLinks_url;
                        return /*#__PURE__*/ _jsxs("a", {
                            className: "header-link subsection-link",
                            href: (_headerCatalogLinks_url = headerCatalogLinks === null || headerCatalogLinks === void 0 ? void 0 : headerCatalogLinks[url]) !== null && _headerCatalogLinks_url !== void 0 ? _headerCatalogLinks_url : url,
                            onMouseDown: (e)=>onLinkClick(e, link),
                            target: openInNewTab ? "_blank" : "_self",
                            rel: "noreferrer",
                            children: [
                                MobileIcon && /*#__PURE__*/ _jsx(PictureComponent, {
                                    src: MobileIcon,
                                    className: "mobile-icon"
                                }),
                                translate(linkTitle),
                                isPopular && /*#__PURE__*/ _jsx("div", {
                                    className: "new-badge-component-wrapper",
                                    children: /*#__PURE__*/ _jsx(BadgeComponent, {
                                        badgeText: translate(badgeText),
                                        badgeColorName: badgeColorName,
                                        badgeTextColorName: badgeTextColorName,
                                        badgeStrokeColorName: badgeStrokeColorName
                                    })
                                })
                            ]
                        }, `link_${linkIndex}`);
                    })
                })
            ]
        }, `section_${sectionIndex}`);
    };
    const onKeyDown = useCallback(generateOnKeyDownHandler(openMenu), [
        isOpen,
        id
    ]);
    const style = useMemo(()=>getStyle(), [
        isOpen
    ]);
    return /*#__PURE__*/ _jsxs(StyledLinkWithSectionsMenuComponent, {
        className: classnames("link-with-menu-mobile-component", {
            "is-open": isOpen
        }),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "link-with-menu-title-wrapper",
                tabIndex: 0,
                onClick: openMenu,
                onKeyDown: onKeyDown,
                onMouseDown: preventFocusOnMouseDown,
                "aria-label": translate(title),
                role: "button",
                "aria-haspopup": "menu",
                "aria-expanded": isOpen,
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: "link-with-menu-title-text",
                        children: [
                            TitleIcon && /*#__PURE__*/ _jsx(TitleIcon, {
                                className: "link-with-menu-title-svg"
                            }),
                            translate(title)
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ArrowDown, {
                        className: "link-with-menu-title-icon"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classnames("link-with-menu-links-wrapper"),
                style: style,
                children: /*#__PURE__*/ _jsx("div", {
                    ref: menuEl,
                    children: links.map((section, sectionIndex)=>renderSection({
                            section,
                            sectionIndex
                        }))
                })
            })
        ]
    });
};
export default withGenericConfig(LinkWithSectionsMenuComponent);
